import React from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {SelectField} from "./FilterComponentStyles";

const MotorTypeFilter = ({
    value,
    onChange,
    disabled = true,
    initialCall = true,
    mode = undefined,
    showAllOption = true,
    allowClear = false,
    ...props
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const [motorTypesLoading, motorTypes] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.listMotorTypes.bind(null, {}),
        initialCall: initialCall
    });
    return (
        <React.Fragment>
            <h5>Motor Tipi</h5>
            <SelectField
                showSearch
                loading={motorTypesLoading}
                data-testid="motorTypeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled && motorTypesLoading}
                mode={mode}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear={allowClear}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {motorTypes &&
                    motorTypes?.length > 0 &&
                    motorTypes?.map(motorType => (
                        <SelectField.Option
                            key={motorType._id}
                            value={motorType._id}
                            data-testid="motorTypeSelect_option"
                        >
                            {motorType.label.tr}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    );
};

export default MotorTypeFilter;
